import Cookies from "js-cookie";

import en from "./data/en.json";
import ja from "./data/ja.json";

const FALLBACK_LOCALE = 'en';
const TRANSLATIONS = { en, ja };
const LOCALE_COOKIE_NAME = 'arcanumxiv.locale';

export function switchLanguage(locale) {
  if (supportedLanguage(locale)) {
    window.AlpineI18n.locale = locale;
  }
};

function supportedLanguage(locale) {
  return Object.keys(TRANSLATIONS).includes(locale);
};

function detectLocale() {
  return Cookies.get(LOCALE_COOKIE_NAME) || FALLBACK_LOCALE;
};

function cacheLocale(locale) {
  Cookies.set(LOCALE_COOKIE_NAME, locale, { expires: 365, secure: true });
};

document.addEventListener('alpine-i18n:ready', function() {
  window.AlpineI18n.create(detectLocale(), TRANSLATIONS);
  window.AlpineI18n.fallbackLocale = FALLBACK_LOCALE;
});

document.addEventListener('alpine-i18n:locale-change', function() {
  cacheLocale(window.AlpineI18n.locale);
});
